<template>
    <div>
        <h2>出庫元データの選択</h2>

        <v-data-table
            :headers="headers"
            :items="not_exit_entries"
            class="elevation-1"
            @click:row="clickRow"
            no-data-text="データはありません"
        >
        </v-data-table>

    </div>
</template>


<script>
export default {
    data() {
        return {
            menu: false,
            headers: [
                { text: 'カード名', value: 'card.card_name' },
                { text: '色', value: 'card.color' },
                { text: '収録弾', value: 'card.lot' },
                { text: '買取日', value: 'buy_date' },
                { text: '買取方法', value: 'buy_method' },
                { text: 'カードの状態', value: 'condition' },
                { text: '金額(円)', value: 'buy_price' },
                { text: '数量', value: 'stock_quantity' },
            ],
            not_exit_entries: [],
        }
    },
    methods: {
        clickRow(row) {
            this.$router.push({
                name: 'RegisterExit',
                params: {
                    entry_id: row.id
                }
            })
        },
    },
    mounted: function () {
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/entry/stocks`, {
            params: {
                card_id: this.$route.params.card_id,
                account_id: this.$store.getters.getStoreId,
                condition: this.$route.params.condition
            }
        })
        .then(res => {
            this.not_exit_entries = res.data
        })
        .catch(() => {
            alert(e)
        })
    }
}
</script>
